export default "__VITE_ASSET__ClLWzgy___"